import { Button, Card, CardContent, Progress } from "alm-react-components";
import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { DateFormat } from "../../assets/constants/constants";


import {
  badgeUrl,
  isDateInRange,
  limitOverview
} from "../../lib/utils";
import defaultImg from '/src/assets/images/default-image-library.png';
import { AppContext } from "../../context/AppProvider";
import { useContext } from "react";
import SvgIcon from "./SvgIcon";

export const CardBox = ({ cardInfo }: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useContext(AppContext);

  const today = cardInfo?.quarterStartDate
    ? new Date(cardInfo.quarterStartDate).toISOString().split("T")[0]
    : null;

  // Define quarter start and end ranges for current and next quarters
  const currentQuarterEnd = state.quarterDeatil?.nextQuarter?.start
    ? new Date(state.quarterDeatil?.nextQuarter.start)
    : new Date();

  // Determine if the dot should blink for the current quarter
  const shouldBlinkCurrentQuarter = isDateInRange(
    state.quarterDeatil?.currentQuarter?.start || null,
    currentQuarterEnd || null,
    today || null
  );

  return (
    <Card
      style={{ backgroundImage: cardInfo?.bannerUrl ? (`url('${cardInfo?.bannerUrl}')`) : (`url(${defaultImg})`) }} className=" bg-cover bg-center rounded-2xl mt-10 border border-cardBorder dark:border-cardBorder"
    >
      <CardContent className="grid gap-4 md:py-8 md:px-8 md:pb-7">
        <div className="flex items-start  justify-between">
          <div className="flex-1 min-w-0 me-4">
            <div className="relative">
              <div className="flex items-center text-xs border max-sm:mt-4 p-2 py-1 absolute top-0 left-0 rounded-md text-white px-1.5 bg-[#181818] w-[max-content]">
                <p
                  className={`w-[8px] h-[8px] ${shouldBlinkCurrentQuarter
                    ? "rounded-full bg-red-500 circle mt-2 ml-2"
                    : "rounded-lg bg-red-500"
                    }`}
                ></p>
                <p className="mx-2 uppercase text-red-50">
                  {t("Program.liveProgram")}
                </p>
              </div>
            </div>
            <h4 className="mb-2 mt-20 lg:text-lg uppercase font-barlowLight text-left tracking-wider">
              {t('Program.text')}
            </h4>
            <h1 className="mb-6 leading-none font-barlowRegular text-white lg:text-3xl xl:text-4xl text-left">
              {cardInfo?.name}
            </h1>
            <p className="mb-10 text-base font-opensansRegular text-left md:w-[52%]">
              {cardInfo && limitOverview(cardInfo?.description)}
            </p>
          </div>
          <div className="flex-shrink-0 inline-flex items-center mt-10 text-base font-opensansSemiBold text-gray-900 dark:text-white">
            <img
              className="yellow max-w-[84px]"
              src={badgeUrl(cardInfo?.relationshipInstancesId, cardInfo?.fullCardIncluded)}
              alt="Basics image"
            />
          </div>
        </div>
        <div className="flex items-baseline justify-between">
          <p className="leading-7 text-base [&:not(:first-child)]:mt-6 md:w-72 dark:text-gray-300 font-light">
            <span className="capitalize">{moment(cardInfo.quarterStartDate).format(DateFormat)}</span> |{' '}
            <span>
              {cardInfo.weeks} {t('Common.weeks')}
            </span>
          </p>
          <div className="flex-shrink-0 inline-flex items-center  text-base font-opensansSemiBold text-gray-900 dark:text-white mb-2">
            {/* {
              cardInfo.quarterStartDate !== new Date() ? */}
            <Button
              className={`w-full  flex gap-2 space-y-1.5 md:px-8 space-x-1.5 md:min-h-10  mt-12 h-auto py-2 text-base mb-4 truncate `}
              onClick={() => navigate(`/program/${cardInfo.id}`)}
            >
              {t('Program.goToProgram')}
              <SvgIcon
                iconName="right-line-arrow" //name of svg file
                svgProp={{
                  className: 'logo cursor-pointer mt-1',
                }}
              />
              {/* <img src={rightArrow} alt={" "} className="logo text-sm w-[23px] h-[18px]" /> */}
              {/* <FontAwesomeIcon icon={faArrowRight} className=" ms-3 text-sm" /> */}
            </Button>
            {/* : */}
            {/* <Button
                  onClick={() => navigate(`/program/${cardInfo?.id}`)}
                  variant="outline"
                  className="w-full space-y-1.5 space-x-1.5 h-auto text-base font-normal bg-transparent  md:min-h-10 md:px-14 dark:border-white"
                >
                  {t('Program.goToProgram')}
                  <FontAwesomeIcon icon={faArrowRight} className=" ms-3 text-sm" />
                </Button> */}
            {/* } */}


          </div>
        </div>
      </CardContent>
      <div className="bg-fillLightGrayCard p-5 rounded-t-none rounded-b-2xl border-1 border border-cardBorder">
        <div className="flex items-center">
          <div className="flex-1 min-w-0">
            <Progress value={cardInfo.progress} className="w-full h-[7px] bg-fillDarkGrayCard" />
          </div>
        </div>
      </div>
    </Card>
  );
};
